module.exports = __webpack_public_path__ + "static/media/pre3.b9c4736c.jpg";